import { Env } from '@stencil/core';

/**
 * Environment variables
 * Overwrite config by env-vars in build: dev, stage, prod
 * clientHash is the clientSecret. Renamed because tenable otherwise detects a vulnerability
 * */
export const endpoints = {
    preferences: {
        affinities: 'https://mcqk1-pt73plx40hd2kd2lkc-5by.pub.sfmc-content.com/isqdvf0ec05',
        mail: 'https://cloud.email.rational-online.com',
        auth: 'https://mcqk1-pt73plx40hd2kd2lkc-5by.auth.marketingcloudapis.com/v2/token',
        clientId: 'k13xrp5t5vioub9b22oshn33',
        clientHash: 'ZLTfDObqjIXB5U61Shdzigm8',
        accountId: 100009725
    }
}

const BASE_ASSET_PATH = '/stencil/stencil-assets/';

const configs = {
  dev: {
    assetPath: `${BASE_ASSET_PATH}`,
  },
  stage: {
    assetPath: `${BASE_ASSET_PATH}`,
  },
  prod: {
    assetPath: `/media${BASE_ASSET_PATH}`,
  }
};

export const stencilEnv = configs[Env.stencilEnv];
